import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { RadioError } from 'components/fields'
import styles from './radio-group.styl'

export default class RadioGroup extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    horizontal: PropTypes.bool,
    labelless: PropTypes.bool,
    secondary: PropTypes.bool,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    intlKey: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    tertiary: PropTypes.bool
  }

  static defaultProps = {
    horizontal: false,
    labelless: false
  }

  render() {
    const {
      label,
      labelless,
      children,
      horizontal,
      disabled,
      errors,
      name,
      secondary,
      tertiary,
      intlKey
    } = this.props
    const secondaryClass = secondary ? styles.secondary : ''
    const tertiaryClass = tertiary ? styles.tertiary : ''

    return (
      <div
        className={`${styles.formGroup} ${secondaryClass} ${tertiaryClass}`}
      >
        {!labelless &&
          <div>
            <span className={`control-label ${styles.controlLabel}`}>
              {intlKey
                ? <FormattedMessage id={intlKey} defaultMessage={label} />
                : label}
            </span>
          </div>}

        {!children.length &&
          React.cloneElement(children, {
            horizontal,
            disabledGroup: disabled,
            secondary,
            tertiary
          })}
        {children &&
          children.length > 0 &&
          children.map(
            (item, index) =>
              item &&
              React.cloneElement(item, {
                horizontal,
                key: index,
                disabledGroup: disabled,
                secondary,
                tertiary
              })
          )}

        {name && errors && <RadioError name={name} />}
      </div>
    )
  }
}
